import { render } from "./NewsType.vue?vue&type=template&id=0ccbf206"
import script from "./NewsType.vue?vue&type=script&lang=js"
export * from "./NewsType.vue?vue&type=script&lang=js"

import exportComponent from "E:\\heguang\\bm365\\src\\manage\\node_modules\\vue-loader-v16\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__